import React, { Component } from 'react';
import { List }             from 'material-ui/List';
import PlaceListItem        from './PlaceListItem';
import PlaceGridItem        from './PlaceGridItem';
import Subheader            from 'material-ui/Subheader';

import './../css/PlaceList.css';
import './../css/App.css';

class PlaceList extends Component
{
    renderListItems() {
        return this.props.nearby.map((place) => {
            return (
                <PlaceListItem
                    key={ place.id }
                    place={ place }
                    distanceText=" from here"
                />
            );
        });
    }

    renderList = () => {
        if (0 < this.props.nearby.length)
        {
            let places = this.renderListItems();

            return (
                <div className="places-list-nearby">
                    <List>
                        <Subheader>Nearby:</Subheader>
                        { places }
                    </List>
                </div>
            );
        }
        else
        {
            return null;
        }
    };

    renderGridItems = () => {
        return this.props.nearby.map((place) =>
        {
            return (
                <PlaceGridItem
                    key={ place.id }
                    place={ place }
                    distanceText=" from here"
                />
            );
        });
    };

    renderGrid = () => {
        if (0 < this.props.nearby.length)
        {
            return (
                <div className="places-grid-nearby">
                    <Subheader>Nearby:</Subheader>
                    <ul className="rig columns-3">
                        <div className="grid-container">{ this.renderGridItems() }</div>
                    </ul>
                </div>
            );
        }
    };

    render() {
        let list = this.renderList();
        let grid = this.renderGrid();
        return (
            <div>
                { list }
                { grid }
            </div>
        );
    }
}

export default PlaceList;


// WEBPACK FOOTER //
// ./src/components/PlaceNearBy.js